import React, { useContext, useEffect } from 'react'

import { success } from '@react/react-spectrum/Toast'
import Button from '@react/react-spectrum/Button'
import Checkmark from '@react/react-spectrum/Icon/Checkmark'
import Close from '@react/react-spectrum/Icon/Close'
import Clock from '@react/react-spectrum/Icon/Clock'
import Well from '@react/react-spectrum/Well'
import Wait from '@react/react-spectrum/Wait'
import Help from '@react/react-spectrum/Icon/Help'
import OverlayTrigger from '@react/react-spectrum/OverlayTrigger'
import Tooltip from '@react/react-spectrum/Tooltip'

import Carousel from 'react-material-ui-carousel'

import { useOffer } from '../../../data/hooks'
import { ProfileContext } from '../../../root/ProfileContext'
import { RootContext } from '../../../root/RootContext'

import './Recommendation.scss'

export default function Recommendation({ meta, content }) {
  const profileContext = useContext(ProfileContext)
  const rootContext = useContext(RootContext)
  const currentProfile = profileContext.state.currentProfile

  const idNamespace = currentProfile?.searchParams?.entityIdNS
  const idValue = currentProfile?.searchParams?.entityId

  //flatten decisionScopes into one single propositionRequest array
  let propositionRequests = [
    { ds: content.decisionScope1, ic: content.itemCount1 },
    { ds: content.decisionScope2, ic: content.itemCount2 },
    { ds: content.decisionScope3, ic: content.itemCount3 },
  ]
    .filter((activity) => activity.ds && activity.ds.length > 0)
    .map((activity, index) => {
      let ds = JSON.parse(activity.ds)
      ds['xdm:itemCount'] = activity.ic
      return JSON.stringify(ds)
    })
    //   .map((ds) => atob(ds))
    .join(',')

  // hook to fetch offer with given parameters
  const [{ data, loading, error }, fetchData] = useOffer()

  useEffect(() => {
    if (currentProfile && propositionRequests.length > 0) {
      fetchData({
        orgId: rootContext.project.integrations.aep.imsOrg.id,
        sandboxName: rootContext.project.integrations.aep.sandbox,
        entityIdNS: idNamespace,
        entityId: idValue,
        propositionRequests: `[${propositionRequests}]`,
      })
    }
  }, [currentProfile])

  const handleChange = (other, active) => {}

  return (
    <div className='profile-module recommendation'>
      <div className='module-content'>
        {currentProfile && loading && <Wait size='S' style={{ marginLeft: 10 }} />}
        {error && (
          <div>
            <i>Failed to retrieve offer recommendation.</i>{' '}
            <OverlayTrigger placement='right'>
              <Button className='tooltip-btn' variant='tool' icon={<Help />} />
              <Tooltip>check browser console log for more details</Tooltip>
            </OverlayTrigger>
          </div>
        )}

        {currentProfile && content.description && <Well>{content.description}</Well>}
        {currentProfile && data && (
          <div className='caroussel-container' align='center'>
            <Carousel
              className='carousel'
              autoPlay={false}
              animation='slide'
              indicators={true}
              timeout={500}
              navButtonsAlwaysVisible={true}
              next={handleChange}
              prev={handleChange}
            >
              {data.map((offer, index) => {
                return <RecoCard {...offer} key={index} />
              })}
            </Carousel>
          </div>
        )}
      </div>
    </div>
  )

  function RecoCard(offer, key) {
    try {
    } catch (e) {
      console.error('ERROR in RecoCard:', e)
      return (
        <div className='Project' key={key}>
          <div className='error'>
            <i>Unable to parse json placement</i>
            <OverlayTrigger placement='right'>
              <Button className='tooltip-btn' variant='tool' icon={<Help />} />
              <Tooltip>check browser console log for more details</Tooltip>
            </OverlayTrigger>
          </div>
        </div>
      )
    }

    return (
      <div className='Project' key={key}>
        <h2 id='offerName'>{offer?.name}</h2>
        <p id='offerDescription'>{offer?.description}</p>
        <div>
          {offer?.image ? (
            <img id='offerImage' src={offer?.image} className='offerImage' />
          ) : (
            <div className='offerImage' dangerouslySetInnerHTML={{ __html: offer?.content }} />
          )}
        </div>
        <div className='buttonGroup'>
          <Button
            name='sendOffer'
            variant='secondary'
            label='Interested'
            icon={<Checkmark size='S' />}
            onClick={() => {
              document.querySelector('button[name="sendOffer"]').dispatchEvent(
                new CustomEvent('sendOffer', {
                  detail: {
                    eventType: 'offer.accepted',
                    proposition: {
                      id: offer?.id,
                      offerId: offer?.offerId,
                      name: offer?.name,
                      description: offer?.description,
                      image: offer?.image,
                      link: offer?.link,
                    },
                  },
                })
              )
              success('Offer sent to customer.', {
                onClose: () => {},
                timeout: 4000,
              })
            }}
          ></Button>
          <Button
            name='sendOffer'
            variant='secondary'
            label='Not Interested'
            icon={<Close size='S' />}
            onClick={() => {
              document.querySelector('button[name="sendOffer"]').dispatchEvent(
                new CustomEvent('sendOffer', {
                  detail: {
                    eventType: 'offer.declined',
                    proposition: {
                      id: offer?.id,
                      offerId: offer?.offerId,
                      name: offer?.name,
                      description: offer?.description,
                      image: offer?.image,
                      link: offer?.link,
                    },
                  },
                })
              )
              success('Offer declined.', {
                onClose: () => {},
                timeout: 4000,
              })
            }}
          ></Button>
          <Button
            name='laterOffer'
            variant='secondary'
            label='Maybe Later'
            icon={<Clock size='S' />}
            onClick={() => {
              success('Offer to be reproposed later.', {
                onClose: () => {},
                timeout: 4000,
              })
            }}
          ></Button>
        </div>
      </div>
    )
  }
}

Recommendation.requiresLaunch = true
